export type ProdutoClonado = {
  p_cod_loja: number | number[];
  p_cod_produto_origem: string;
  p_gtin: string;
  p_cod_departamento: number;
  p_cod_ncm: number;
  p_val_venda: number;
  p_qtd_estoque: number;
  p_des_produto: string;
};

export class SessionStorageService {
  private static getKey(key: string, codTela: number): string {
    return `kvx_${key}_${codTela}`;
  }

  static saveProduto(
    key: string,
    produto: ProdutoClonado,
    codTela: number,
  ): void {
    const data = JSON.stringify(produto);
    sessionStorage.setItem(this.getKey(key, codTela), data);
  }

  static getProduto(key: string, codTela: number): ProdutoClonado | null {
    const data = sessionStorage.getItem(this.getKey(key, codTela));
    return data ? (JSON.parse(data) as ProdutoClonado) : null;
  }

  static deleteProduto(key: string, codTela: number): void {
    sessionStorage.removeItem(this.getKey(key, codTela));
  }

  static clearAll(): void {
    sessionStorage.clear();
  }
}
